import { getFulfillmentStatus, getOrderStatus } from './FulfillmentStatus';
import { FULFILLMENT_TYPE } from '../../../constants/status';
import { searchNestedProperties } from './safelyAccessNestedProperties';
import { IFulfillmentGroup } from '../../../models/order-details';

export const setTrackingButtonVisibility = (
  statusCode: number,
  fulfillmentType: FULFILLMENT_TYPE,
  fulfillmentGroup: IFulfillmentGroup | undefined,
) => {
  const orderStatus = getOrderStatus(statusCode);
  const fulfillmentMethod = getFulfillmentStatus(fulfillmentType);

  const shouldSkipTracking =
    orderStatus?.isBackOrdered &&
    orderStatus?.isCanceled &&
    orderStatus?.isReturned;

  if (fulfillmentGroup === undefined) return false;

  if (fulfillmentMethod?.isFulfillmentSTHorBOSS) {
    if (shouldSkipTracking) return false;
    if (
      Object.keys(fulfillmentGroup ?? {}).filter((element) =>
        ['shippingAndHandling', 'shipments', 'shipment'].includes(element),
      ).length === 0
    )
      return false;

    return true;
  }
  if (fulfillmentMethod?.isMA) {
    if (
      searchNestedProperties(
        ['shippingAndHandling', 'applianceDeliveries', 0, 'deliveryTrackerUrl'],
        fulfillmentGroup,
      )
    ) {
      return true;
    }

    return !orderStatus?.isDelivered && !orderStatus?.isOrderCompleted;
  }

  if (fulfillmentMethod?.isFulfillmentBODFSorDFS) {
    return orderStatus?.isShipped;
  }

  return (
    orderStatus?.isProcessing ||
    orderStatus?.isReadyForPickup ||
    orderStatus?.isBODFSOnSchedule ||
    (!shouldSkipTracking && !orderStatus?.isReturnStarted)
  );
};

export const isLessThan90DaysBetweenDates = (
  date1: Date,
  date2: Date,
): boolean => {
  const diff = Math.abs(date1.getTime() - date2.getTime());
  return Math.floor(diff / (1000 * 60 * 60 * 24)) < 90;
};
